exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".block-order .btn[data-v-264fecb5]{flex:0 1 auto}.block-order .bg[data-v-264fecb5]{background-size:contain}", ""]);

